/* RendererUtils.js */

"use strict";
const _ = require("lodash");
const InputCheckControl = require("@gluenetworks/steve_ui_core").Control.Boolean.InputCheckbox;

class RendererUtils {
    static createLabelElement(elemName, labelText) {
        let labelElem = document.createElement(elemName);
        labelElem.classList.add("themed-label");
        labelElem.innerText = labelText;
        return labelElem;
    }

    static groupGridRowElements(tabIndex, gridElem, groupName, labelText, ...childElements) {
        return RendererUtils.groupGridRowElementsBefore(undefined, tabIndex, gridElem, groupName, labelText, ...childElements);
    }

    static groupGridRowElementsBefore(beforeElem, tabIndex, gridElem, groupName, labelText, ...childElements) {
        if (childElements.length === 1 && _.isArray(childElements[0])) {
            childElements = childElements[0];
        }
        let parts = [];
        if (labelText) {
            let labelElem = RendererUtils.createLabelElement(`${groupName}-label`, labelText);
            gridElem.insertBefore(labelElem, beforeElem);
            labelElem.classList.add("inline-label-gl");
            parts.push(labelElem);
        }
        let containerElem = document.createElement(`${groupName}-container`);
        containerElem.classList.add(childElements[0] instanceof InputCheckControl ? "inline-check-container-gl" : "inline-container-gl");
        gridElem.insertBefore(containerElem, beforeElem);
        childElements.forEach((childElement, idx) => {
            if (childElement) {
                if (_.isString(childElement)) {
                    childElement = RendererUtils.createLabelElement(`${groupName}-label-${idx}`, childElement);
                }
                let childNode = childElement;
                if (!(childElement instanceof Node) && childElement.renderer) {
                    childNode = childElement.renderer.rootElement;
                    childNode.setAttribute("tabIndex", tabIndex++);
                }
                childNode.classList.add(childElement instanceof InputCheckControl ? "inline-check-control-gl" : "inline-control-gl");
                containerElem.appendChild(childNode);
                parts.push(childElement);
            }
        });
        parts.push(containerElem);
        return parts;
    }

    static removeChildElements(parentElem, ...elements) {
        if (elements.length === 1 && _.isArray(elements[0])) {
            elements = elements[0];
        }
        elements.forEach((element) => {
            if (element && element.parentElement === parentElem) {
                parentElem.removeChild(element);
            }
        });
    }

    static appendChildElements(parentElem, ...elements) {
        if (elements.length === 1 && _.isArray(elements[0])) {
            elements = elements[0];
        }
        elements.forEach((element) => {
            element = element instanceof Node ? element : element.renderer.rootElement;
            if (element && !parentElem.contains(element)) {
                parentElem.appendChild(element);
            }
        });
    }

    static hideElements(...elements) {
        RendererUtils.setElementsVisibility(false, elements);
    }

    static showElements(...elements) {
        RendererUtils.setElementsVisibility(true, elements);
    }

    static setElementsVisibility(show, ...elements) {
        if (elements.length === 1 && _.isArray(elements[0])) {
            elements = elements[0];
        }
        elements.forEach((element) => {
            element = element instanceof Node ? element : element.renderer.rootElement;
            if (show) {
                element.classList.remove("hidden");
            } else {
                element.classList.add("hidden");
            }
        });
    }
}
module.exports = RendererUtils;
